import { render } from "./ProfileSettingsModal.vue?vue&type=template&id=3b796d7e&scoped=true"
import script from "./ProfileSettingsModal.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsModal.vue?vue&type=script&lang=js"

import "./ProfileSettingsModal.vue?vue&type=style&index=0&id=3b796d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b796d7e"]])

export default __exports__